import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import router from './router'
import axios from 'axios'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'

Vue.use(VueRouter);
Vue.use(Buefy);
Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'gw2scratch-options',
  storage: window.localStorage,
  modules: ['options']
});

const options = {
  state: {
    passwordEntered: false,
    gw2ApiKey: "",
    scratchApiKey: "",
    scratchApiUrl: "https://api.gw2scratch.com/",
  },
  mutations: {
    setPasswordEntered(state, value) {
      state.passwordEntered = value;
    },
    setGw2ApiKey(state, value) {
      state.gw2ApiKey = value;
    },
    setScratchApiKey(state, value) {
      state.scratchApiKey = value;
      axios.defaults.headers.common['Authorization'] = "Bearer " + value;
    },
    setScratchApiUrl(state, value) {
      state.scratchApiUrl = value;
      axios.defaults.baseURL = value;
    },
  },
};

const permissions = {
  state: {
    permissions: [],
  },
  mutations: {
    setPermissions(state, value) {
      state.permissions = value;
    },
  },
};

const store = new Vuex.Store({
  modules: {
    options: options,
    permissions: permissions
  },
  plugins: [vuexPersist.plugin]
});

axios.defaults.baseURL = store.state.options.scratchApiUrl;
if (store.state.options.scratchApiKey) {
  axios.defaults.headers.common['Authorization'] = "Bearer " + store.state.options.scratchApiKey;
}

import {getPermissionsFromApi} from './api'

getPermissionsFromApi().then(permissions => store.commit('setPermissions', permissions));

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
